module.exports = __webpack_public_path__ + "static/img/094_TO8_1769.f73e06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/094_TO8_1769.jpg
// module id = v/8g
// module chunks = 0